<div class="alert alert-danger" role="alert" *ngIf="isInvalid">
  The provided QR code is not valid. You will be redirected shortly.
</div>

<!-- Site Access Control code: render the sign-in flow. -->
<app-code-feature-access-control *ngIf="code && scanState === 'site' && code.feature == 'Access Control'" [code]="code" [code_hash]="code_hash"></app-code-feature-access-control>

<!-- Asset code: render the public asset details inline. -->
<app-noauth-asset-public-details *ngIf="code && scanState === 'asset' && code.asset" [asset]="code.asset"></app-noauth-asset-public-details>

<!-- Code is not linked to a site or an asset: nothing to do. -->
<div class="alert alert-info m-3" role="alert" *ngIf="code && scanState === 'not_linked'">
  This QR code is not linked to anything yet, so no action will be performed. Please contact your administrator.
</div>
